
import Vue from "vue";
import WelcomeToTheMoonScoresByAdventure from "@/components/WelcomeToTheMoonScoresByAdventure.vue";
import WelcomeToTheMoonScoresByDate from "@/components/WelcomeToTheMoonScoresByDate.vue";
import WelcomeToTheMoonScoresByCampaign from "@/components/WelcomeToTheMoonScoresByCampaign.vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "ScoresWelcomeToTheMoon",
  data: () => ({
    tab: null,
  }),
  components: {
    WelcomeToTheMoonScoresByAdventure,
    WelcomeToTheMoonScoresByDate,
    WelcomeToTheMoonScoresByCampaign,
  },
  async beforeMount() {
    if (!this.welcomeToTheMoonPlays.length) {
      this.$store.dispatch("getWelcomeToTheMoonPlays");
    }
  },
  computed: {
    ...mapState([
      "welcomeToTheMoonPlays",
      "welcomeToTheMoonAdventures",
      "welcomeToTheMoonCampaigns",
    ]),
  },
});
